import { useTravelCreditOneCMS } from './travelCreditOneCMSFetchye';

export const useDataFromOneCMS = (key) => {
  const { data } = useTravelCreditOneCMS();
  return key?.split('.')?.reduce((remainingObj, nextKey) => remainingObj?.[nextKey], data?.body ?? {});
};
